import { baseApi } from "./baseQuery";

interface AuditLogParams {
  page?: number;
  page_size?: number;
  start_date?: string;
  end_date?: string;
  workspace_id?: string;
  status?: string;
  search?: string;
}

interface AuditLogDetailParams {
  id: string;
}

const auditLogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAuditLogs: build.query({
      query: (params: AuditLogParams) => {
        const queryParams = new URLSearchParams();

        // Always append all parameters, even if empty
        queryParams.append('page', params.page?.toString() || '1');
        queryParams.append('page_size', params.page_size?.toString() || '20');
        queryParams.append('start_date', params.start_date || '');
        queryParams.append('end_date', params.end_date || '');
        queryParams.append('workspace_id', params.workspace_id || '');
        queryParams.append('status', params.status || '');
        queryParams.append('search', params.search || '');

        return {
          url: `/api/v1/audit-logs?${queryParams.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['auditLogs'],
    }),

    getAuditLogDetail: build.query({
      query: (params: AuditLogDetailParams) => ({
        url: `/api/v1/audit-logs/detail?id=${params.id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAuditLogsQuery,
  useLazyGetAuditLogsQuery,
  useGetAuditLogDetailQuery,
  useLazyGetAuditLogDetailQuery
} = auditLogApi;

export default auditLogApi;
